<script>
    import classnames from 'clsx';
    import I18n from '@js/modules/translations';
    import {SLOPE_BANDS} from '@js/modules/maps/slopeGrade';

    const {
        class: className
    } = $props();

    const slopeRanges = SLOPE_BANDS;
</script>

<div class={classnames('map-slope-legend', className)}>
    <div class="slope-legend-title">
        {I18n.t('js.maps.toolbar.slope_color.legend_title')}
    </div>

    <div class="slope-legend-items">
        {#each slopeRanges as range (range)}
            <div class="slope-legend-item">
                <span class="slope-legend-color"
                      style="background-color: {range.color}"></span>
                <span class="slope-legend-label">{range.label}</span>
            </div>
        {/each}
    </div>
</div>
